import ListItemsItem from './component/list-items-item'
import ListItemsRoot from './component/list-items-root'

const ListItemComponent = {
  Root: ListItemsRoot,
  Item: ListItemsItem
}

export default ListItemComponent
